export default __webpack_public_path__ + "static/media/start-btn.9d7f1ef7.webp";